export const iconFontAwesomeUsersPeoplePersonDotsFromLine = (
	<i className="fa-solid fa-person-dots-from-line"></i>
);
